(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table.js');
"use strict";


const {
  getOddsCaption,
  formatDecimalOdds,
  formatPercentage,
  setUpTipsinfoValue
} = svs.components.tipsen.tipsinfo.utils;
const {
  TableComponent
} = svs.components.tipsen.tipsinfo.tableComponents;
const {
  Trend
} = svs.components.lbUi.trend;
const {
  AnalysisForecast,
  TipsinfoTableRow
} = svs.components.tipsen.tipsinfo;
const TipsinfoTable = _ref => {
  let {
    layOutProps
  } = _ref;
  const {
    drawNumber,
    eventNumber,
    favourites,
    hasTioTidningarValues,
    hasTipsinfoStats,
    isReduceFree,
    isResultOrMybets,
    isStartOddsEnabled,
    matchId,
    outcomeLabels,
    productId,
    selectFormattedDistribution,
    selectFormattedOdds,
    shouldDisplayFavourites,
    shouldDisplayOdds,
    shouldDisplayStartOdds,
    shouldDisplaySvenskaFolket,
    shouldDisplayTioTidningar,
    showMatchAnalyseForecast,
    startOdds,
    tioTidningarTips
  } = layOutProps;
  return React.createElement(TableComponent, {
    ariaDescription: "Tipsinformation f\xF6r match nummer ".concat(eventNumber)
  }, React.createElement(TableComponent.Header, {
    className: isReduceFree && hasTipsinfoStats ? '' : 'sr-only'
  }, React.createElement(TableComponent.Header.Row, null, React.createElement(TableComponent.Header.Row.HeaderCell, null, isReduceFree && hasTipsinfoStats ? '' : 'Tipsinfo'), outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(outcomeLabel => React.createElement(TableComponent.Header.Row.HeaderCell, {
    className: "tips_info_table_content_header",
    key: "header_content_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text),
    scope: "col"
  }, outcomeLabel.text)))), React.createElement(TableComponent.Body, null, shouldDisplaySvenskaFolket && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-svenska-folket",
    title: "Svenska folket"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: "sv_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  }, React.createElement(Trend, {
    postfixSymbol: "%",
    selectorFunction: selectFormattedDistribution(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  })))), shouldDisplayOdds && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-odds",
    title: getOddsCaption({
      isStartOddsEnabled,
      isResultOrMybets
    })
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => React.createElement(TableComponent.Body.Row.ContentCell, {
    key: "odds_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  }, React.createElement(Trend, {
    selectorFunction: selectFormattedOdds(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
  })))), shouldDisplayFavourites && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-favourites",
    title: "Favoritskap"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _favourites$current;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "favourites_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
    }, setUpTipsinfoValue({
      value: formatPercentage(favourites === null || favourites === void 0 || (_favourites$current = favourites.current) === null || _favourites$current === void 0 ? void 0 : _favourites$current.value[i]),
      sign: '%',
      noValueSign: '-'
    }));
  })), shouldDisplayStartOdds && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-start-odds",
    title: "Startodds"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _startOdds$current;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "startOdds_".concat(drawNumber, "_").concat(outcomeLabel.text)
    }, formatDecimalOdds(startOdds === null || startOdds === void 0 || (_startOdds$current = startOdds.current) === null || _startOdds$current === void 0 ? void 0 : _startOdds$current.value[i]));
  })), shouldDisplayTioTidningar && React.createElement(TipsinfoTableRow, {
    dataTestId: "coupon-row-tips-info-ten-papers",
    title: "Tio Tidningar"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((outcomeLabel, i) => {
    var _tioTidningarTips$cur;
    return React.createElement(TableComponent.Body.Row.ContentCell, {
      key: "tt_".concat(drawNumber, "_").concat(matchId, "_").concat(outcomeLabel.text)
    }, setUpTipsinfoValue({
      value: tioTidningarTips === null || tioTidningarTips === void 0 || (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 ? void 0 : _tioTidningarTips$cur.value[i],
      sign: '',
      noValueSign: hasTioTidningarValues ? '0' : '-'
    }));
  })), showMatchAnalyseForecast && React.createElement(AnalysisForecast, {
    dataTestId: "coupon-row-tips-info-analyse",
    drawId: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  })));
};


setGlobal('svs.components.tipsen.tipsinfo.TipsinfoTable', TipsinfoTable);

 })(window);